import config from "../config"

class CostelGPTService {
    
    constructor(backendUrl) {
        this.backendUrl = backendUrl
    }

    async prompt(question, tone, token) {
        const response = await fetch(
            `${this.backendUrl}/api/v1/prompt?q=${question}&tone=${tone}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            }
        );

        if (!response.ok) {
          if (response.status === 429) {
            return 'Prea multe requesturi in prea putin timp! Intoarce-te in cateva minute...'
          } else {
            return 'Oops! Ceva s-a stricat! Daca problema persista, anunta-l pe adrian.manole@eestec.ro!'
          }
        } else {
          const result = await response.json();
          return result.answer
        }
    }
}

const costelGptService = new CostelGPTService(config.costelgpt)
export default costelGptService